"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ramda = require("ramda");

var joinSort = function joinSort(sort) {
  return function (query) {
    if (!sort) {
      return query;
    }

    var field = sort.alternative || sort.orderBy;
    var direction = sort.orderDirection === 'desc' ? -1 : 1;
    return (0, _ramda.merge)(query, {
      $sort: (0, _defineProperty2.default)({}, field, direction)
    });
  };
};

var _default = joinSort;
exports.default = _default;